<template>
  <a-drawer
      wrapClassName="custom-drawer"
      :maskClosable="false"
      :destroy-on-close="true"
      :title="this.id ? '编辑':'新增'"
      @close="onClose"
      width="800px"
      :visible="addVisible"
      :wrapStyle="{ overflow: 'auto' }"
  >
    <a-form :form="form">
      <a-row :gutter="16" style="padding-bottom: 24px;">
        <a-col :lg="24" :md="24">
          <a-form-item
              label="学工号"
              :labelCol="{ span: 6 }"
              :wrapperCol="{ span: 16 }">
            <a-input
                :disabled="!!record.jdUserCode"
                placeholder="请输入"
                :maxLength="32"
            v-decorator="['jdUserCode',{initialValue: record.jdUserCode,rules:[{required: true, message: '姓名不能为空'}]}]"/>
          </a-form-item>
        </a-col>
        <a-col :lg="24" :md="24">
          <a-form-item
              label="姓名"
              :labelCol="{ span: 6 }"
              :wrapperCol="{ span: 16 }">
            <a-input
                :disabled="!!record.fullName"
                placeholder="请输入"
                :maxLength="32"
                v-decorator="['fullName',{initialValue: record.fullName,rules:[{required: true, message: '姓名不能为空'}]}]"/>
          </a-form-item>
        </a-col>
        <a-col :lg="24" :md="24">
          <a-form-item
              label="所在单位"
              :labelCol="{ span: 6 }"
              :wrapperCol="{ span: 16 }">
            <a-input
                :disabled="!!record.topOrganizeName"
                placeholder="请输入"
                :maxLength="32"
                v-decorator="['topOrganizeName',{initialValue: record.topOrganizeName,rules:[{required: true, message: '所在单位为空'}]}]"/>
          </a-form-item>
        </a-col>

        <a-col :lg="24" :md="24">
          <a-form-item
              label="教育培训内容"
              :labelCol="{ span: 6 }"
              :wrapperCol="{ span: 16 }">
            <a-input
                placeholder="请输入"
                :maxLength="255"
                v-decorator="['remark',{initialValue: record.remark,rules:[{required: true, message: '教育培训内容不能为空'}]}]"/>
          </a-form-item>
        </a-col>

        <a-col :lg="24" :md="24">
          <a-form-item
              label="主办单位"
              :labelCol="{ span: 6 }"
              :wrapperCol="{ span: 16 }">
            <a-input
                placeholder="请输入"
                :maxLength="32"
                v-decorator="['organizeName',{initialValue: record.organizeName,rules:[{required: true, message: '主办单位不能为空'}]}]"/>
          </a-form-item>
        </a-col>

        <a-col :lg="24" :md="24">
          <a-form-item
              label="培训层级"
              :labelCol="{ span: 6 }"
              :wrapperCol="{ span: 16 }">

            <a-radio-group @change="changeType" :options="radioOptions" v-decorator="['radioValue',{initialValue: record.radioValue, rules: [{required: true,message: '请选择培训层级'}]}]">
            </a-radio-group>

            <a-input
                v-if="radioValue === '5'"
                placeholder="请输入"
                :maxLength="32"
                v-model="pxcj"
                />

          </a-form-item>
        </a-col>




        <a-col :lg="24" :md="24">
          <a-form-item
              label="教育培训时间"
              :labelCol="{ span: 6 }"
              :wrapperCol="{ span: 18 }">
            <a-range-picker format="YYYY-MM-DD HH:mm:ss"  :locale="locale" v-decorator="['times',{initialValue: record.times,rules:[{required: true, message: '教育培训时间不能为空'}]}]"/>
          </a-form-item>
        </a-col>


        <a-col :lg="24" :md="24">
          <a-form-item
              label="集中培训和集体学习学时数"
              :labelCol="{ span: 6 }"
              :wrapperCol="{ span: 16 }">
            <a-input-number
                :min="0" :max="100000" :step="1" :precision="0"
                placeholder="请输入"
                :maxLength="255"
                v-decorator="['pxxs',{initialValue: record.pxxs}]"/>
          </a-form-item>
        </a-col>

        <a-col :lg="24" :md="24">
          <a-form-item
              label="网络自学培训学时"
              :labelCol="{ span: 6 }"
              :wrapperCol="{ span: 16 }">
            <a-input-number
                :min="0" :max="100000" :step="1" :precision="0"
                placeholder="请输入"
                :maxLength="255"
                v-decorator="['wlxs',{initialValue: record.wlxs}]"/>
          </a-form-item>
        </a-col>
        <a-col :lg="24" :md="24">
          <a-form-item
              label="附件"
              :labelCol="{ span: 6 }"
              :wrapperCol="{ span: 16 }">
            <fileUpload ref="fileUpload" :file-item="record.fileUrls ? JSON.parse(record.fileUrls) : []" :size="3" />
          </a-form-item>
        </a-col>

      </a-row>
      <div
          :style="{
          position: 'absolute',
          left: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
        }"
      >
        <a-button
            :style="{marginRight: '8px'}"
            @click="onClose"
        >
          取消
        </a-button>
        <a-button @click="handleSubmit" type="primary" :loading="formLoading">保存</a-button>
      </div>

    </a-form>
  </a-drawer>
</template>

<script>
import ACol from 'ant-design-vue/es/grid/Col'
import {Drawer, Form, Button, Input, Row, InputNumber} from "ant-design-vue";
import FormItem from "ant-design-vue/lib/form/FormItem";
import RangePicker from "ant-design-vue/lib/date-picker/RangePicker";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import {add, getById, getUserInfo, update} from "../../../api/educationalTraining";
import moment from 'moment'
import {Group} from "ant-design-vue/lib/radio";
import Message from "ant-design-vue/lib/message";
import fileUpload from "./FileUpload.vue";
// import {RadioGroup} from "ant-design-vue/types/radio/radio-group";
export default {
  name: 'ListAdd',
  components: { ACol ,fileUpload,
    'a-row': Row,
    'a-form-item': FormItem,
    'a-range-picker': RangePicker,
    'a-radio-group': Group,
    'a-form': Form,
    'a-drawer': Drawer,
    'a-button': Button,
    'a-input': Input,
    'a-input-number': InputNumber,
  },
  props: {
    refresh: {
      type: Function,
      default: undefined
    }
  },
  data () {
    return {
      Message,
      radioValue:undefined,
      pxcj:undefined,
      radioOptions:[{value:'1',label:'本级'},{value:'2',label:'校级'},{value:'3',label:'省部级'},{value:'4',label:'国家级'},{value:'5',label:'其他'}],
      record:{},
      id:undefined,
      locale,
      addVisible: false,
      form: this.$form.createForm(this),
      formLoading: false
    }
  },
  computed: {},
  methods: {
    changeType(e){
      if (e.target.value !== '5'){
        this.pxcj = this.radioOptions.find(option => option.value === e.target.value).label
      }
      this.radioValue = e.target.value

    },
    getValueByLabel(label) {
      const option = this.radioOptions.find(option => option.label === label);
      return option ? option.value : '5'; // 如果没有找到对应的 label，返回 '5'
    },
    show (id) {
      if (id){
        this.id = id
        getById({id:id}).then(res => {
          if (res.code === 10000){
            const times = []
            times.push(moment(res.result.strTime))
            times.push(moment(res.result.endTime))
            this.record = res.result
            const radio = this.getValueByLabel(res.result.pxcj)
            this.record.radioValue =  radio
            this.radioValue = radio
            this.pxcj = res.result.pxcj
            this.record.times = times
          }
        })
      }else {
        getUserInfo().then(res =>{
          if (res.code === 10000 && res.result){
            this.record = res.result
          }
        })
      }
      this.addVisible = true
    },
    onClose () {
      this.record  = {}
      this.$refs.fileUpload.refreshUrl([])
      this.addVisible = false
      this.formLoading = false
      this.form.resetFields()
    },
    handleSubmit () {
    const radioValue =   this.form.getFieldValue('radioValue')
      if (radioValue === '5' && !this.pxcj){
        Message.error('请输入其他培训层级')
        return
      }
    const pxxsValue =   this.form.getFieldValue('pxxs')
    const wlxsValue =  this.form.getFieldValue('wlxs')
      if (!pxxsValue && !wlxsValue){
        Message.error('集中培训和集体学习学时数和网络自学培训学时必填一个')
        return
      }

      this.formLoading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          const fileUrls = this.$refs.fileUpload.getFileItem()
          if (fileUrls){
            values.fileUrls = JSON.stringify(fileUrls)
          }
          values.pxcj = this.pxcj
          values.strTime = moment(values.times[0]).format('YYYY-MM-DD HH:mm:ss')
          values.endTime = moment(values.times[1]).format('YYYY-MM-DD HH:mm:ss')
          const fun =  this.id ? update: add
          if (this.id){
            values.id = this.id
          }
          fun(values).then(res => {
            if (res.code === 10000) {
              // this.$message.info(res.msg)
              this.refresh()
              this.onClose()
            }
          }).finally(() => {
            this.formLoading = false
          })
        } else {
          setTimeout(() => {
            this.formLoading = false
          }, 1000)
        }
      })
    }
  }
}
</script>

<style scoped>
/deep/.ant-input{
  border: 1px solid #dedede;
  padding: 0 10px;
}
/deep/.ant-calendar-range-picker-input{
  border: 1px solid #dedede;
  padding: 0 10px;
  height: 32px;
  border-radius: 6px;
}
</style>
